<template>
  <div class="content">
    <div class="block block-form">
      <div class="block-tilte">推广订单</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="状态">
          <el-select v-model="searchForm.order_status" placeholder="请选择状态">
            <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="searchForm.order_id" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.reserved_phone" maxlength="11" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="第三方订单编号">
          <el-input v-model="searchForm.third_order_id" placeholder="请输入第三方订单编号" />
        </el-form-item>
        <el-form-item label="推广位">
          <el-select v-model="searchForm.app_key" placeholder="请选择推广位">
            <el-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单日期">
          <date-picker v-model="searchForm.start_time_bak" placeholder="开始日期" style="width: 150px;" type="date"
            @on-change="handelDateChangeStart">
          </date-picker>
          <span>至</span>
          <date-picker v-model="searchForm.end_time_bak" placeholder="结束日期" style="width: 150px;" type="date"
            @on-change="handelDateChange">
          </date-picker>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-date-picker style="width: 400px;" v-model="searchForm.settlementArr" type="daterange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="拦截状态">
          <el-select v-model="searchForm.interceptStatus" placeholder="请选择拦截状态">
            <el-option v-for="item in interceptStatus" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单类型">
          <el-radio-group v-model="searchForm.orderType" style="margin-left: 10px" @input="selectType">
            <el-radio label="">全部</el-radio>
            <el-radio :label="1">特惠单</el-radio>
            <el-radio :label="3">快出单</el-radio>
            <el-radio :label="5">秒出单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" :loading="listLoading" @click="onFormSearch">查询</el-button>
          <el-button plain type="warning" @click="onFormReset">重置</el-button>
          <el-button :loading="exportLoading" @click="onFormExport">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <Select v-model="searchForm.order_status" style="width:150px" placeholder="全部状态">
          <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
<template>
        <Input v-model="searchForm.order_id" placeholder="订单编号" style="width: 150px;" />
      </template>
<template>
        <Input v-model="searchForm.reserved_phone" placeholder="手机号" style="width: 150px;" />
      </template>
<template>
        <Input v-model="searchForm.third_order_id" placeholder="第三方订单编号" style="width: 150px;" />
      </template>
<template>
        <Select v-model="searchForm.app_key" style="width:150px" placeholder="全部推广位">
          <Option v-for="item in appList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
<template>
        <span>下单日期</span>
        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;"
          @on-change="handelDateChangeStart">
        </DatePicker>
        <span>至</span>
        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak" @on-change="handelDateChange">
        </DatePicker>
      </template>
<template>
        <Select v-model="searchForm.interceptStatus" style="width:150px" placeholder="拦截状态">
          <Option v-for="item in interceptStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <div class="flex" style="margin-top: 10px">
          <span class="search-text">下单订单类型</span>
          <el-radio-group style="margin-left: 10px" v-model="searchForm.orderType" @input="selectType">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">特惠单</el-radio>

            <el-radio :label="3">秒出单</el-radio>
          </el-radio-group>
          <Button type="text" style="background: #FF8622;color: #FFFFFF;margin-left: 10px"
            @click="onFormSearch">查询</Button>
          <Button type="text" style="background: #FF8622;color: #FFFFFF;margin-left: 10px" @click="onFormReset">重置</Button>
          <Button type="text" style="border: 1px solid #FF8622; color: #FF8622;margin-left: 10px"
            @click="onFormExport">下载报表</Button>
        </div>
      </template>
<template>

      </template>
</div> -->
    <div class="block block-top">
      <Table :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName" border>
        <template slot="movie_name" slot-scope="{ row }">
          <span style="cursor: pointer;" @click="getDetail(row)">
            <span style="color: #0099FF;text-decoration: underline;">{{ row.movie_name }}</span>
            <span v-if="row.isChangeSeat == true" style="color: #FF8622;">(已调座)</span>
          </span>
        </template>
        <template slot="reserved_phone" slot-scope="{ row }">
          <span>{{ row.reserved_phone }}</span>
        </template>
        <template slot="thirdPartyStore" slot-scope="{ row }">
          <div>{{ formatDisplayValue(row.storeName) }}</div>
          <div>ID：{{ formatDisplayValue(row.storeId) }}</div>
        </template>
        <template slot="ticketSeller" slot-scope="{ row }">
          <div>{{ formatDisplayValue(row.sellerName) }}</div>
          <div>ID：{{ formatDisplayValue(row.sellerUUID) }}</div>
        </template>
        <template slot="commissionRate" slot-scope="{ row }">
          <span v-if="row.source_type != 2">{{ row.commissionRate }}%</span>
          <div v-else style="text-align: center"> -</div>
        </template>

        <template slot="invoice_amount" slot-scope="{ row }">
          <span>{{ formatDisplayValue(row.invoice_amount) }}</span>
        </template>
        <template slot="refund_amount" slot-scope="{ row }">
          <span>{{ formatDisplayValue(row.refund_amount) }}</span>
        </template>
        <template slot="invoice_tax_amount" slot-scope="{ row }">
          <span>{{ formatDisplayValue(row.invoice_tax_amount) }}</span>
        </template>
        <template slot="refund_time" slot-scope="{ row }">
          <span>{{ formatDisplayValue(row.refund_time) }}</span>
        </template>
        <template slot="app_commission" slot-scope="{ row }">
          <span v-if="row.source_type != 2">{{ row.app_commission }}</span>
          <div v-else style="text-align: center"> -</div>
        </template>
        <template slot="advice_price" slot-scope="{ row }">
          <span>{{ row.advice_price ? row.advice_price : '-' }}</span>
        </template>
        <template slot="order_price" slot-scope="{ row }">
          <span v-if="row.source_type == 2">{{ row.order_price }}</span>
          <div v-else style="text-align: center"> -</div>
        </template>
        <template slot="order_priceApi" slot-scope="{ row }">
          <span v-if="row.pay_amount >= 0">{{ row.pay_amount }}</span>
          <div v-else style="text-align: center"> -</div>
        </template>
        <template slot="deductionRatio" slot-scope="{ row }">
          <span v-if="row.source_type == 2 && row.order_status != 2">{{
            (row.order_price / row.init_price).toFixed(3)
          }}</span>
          <div v-else style="text-align: center"> -</div>
        </template>
        <template slot="handle" slot-scope="{ row }">
          <div class="tableHandleStyle">
            <span v-if="row.canIntercept" class="intercept" @click="interceptBtn(row)">拦截订单</span>
            <span v-if="row.canCuiTicket" class="urge" @click="urgeBill(row)">催出票</span>
            <!-- <span class="urge" v-if="row.canCuiTicket == false">已催</span> -->
            <span v-if="row.canCancelIntercept" class="close" @click="cancelOrderBtn(row)">取消拦截</span>
          </div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :current="searchForm.page" :total="total" show-elevator show-sizer show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <Detail ref='Detail'></Detail>

    <!--取消拦截-->
    <el-dialog :visible.sync="dialog_close" title="取消拦截" width="500px">
      <div class="dialog-content">确认取消拦截？</div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_close = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_closeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--取消拦截-->
    <!--拦截订单-->
    <el-dialog :visible.sync="dialog_intercept" title="拦截订单" width="460px">
      <div class="dialog-content">
        <div class="box">
          <div style="margin-right: 16px;text-align: center">确定发起拦截？发起拦截后不保证拦截成功</div>
          <!--          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入拦截原因" v-model="interceptReason" style="flex: 1;">-->
          <!--          </el-input>-->
        </div>
        <div>
          <span style="color: red;margin-top: 10px">请稍后刷新页面查看结果</span>
        </div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_intercept = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_interceptBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--拦截订单-->
    <!--    拦截成功提示-->
    <el-dialog :before-close="handleClose" :visible.sync="hintShow" title="提示" width="40%">
      <div class="dialog-content">
        <div>
          <div class="dialog-text">已发起拦截。不保证拦截成功，<span style="color: red">请稍后刷新页面查看结果</span>
          </div>
        </div>
        <div class="dialogFooter" style="margin-left: auto;margin-right: 40px;margin-top: 50px">
          <div class="dialogFooter-ok" @click="hintShow = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <!--催出票-->
    <el-dialog :visible.sync="dialog_urge" title="催出票" width="460px">
      <div class="dialog-content">
        <div class="hint">确定催促出票？</div>
        <div class="placeholder">每个订单10分钟内只能发起一次催出票。</div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_urge = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_urgeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--催出票-->
  </div>
</template>
<script>
import questionBtn from '@/assets/img/promotion/btn_doubt.png'
import { Button, DatePicker, Icon, Input, Option, Page, Select, Table, Tooltip } from 'view-design'
import { getOrderList } from '@/api/order'
import { getDate } from '@/utils/date'
import { getHeadImg, getPlatformName, getToken } from '@/utils/auth'
import Detail from '@/views/pc/promotion/order/modal/Detail'
import Vue from 'vue'
import order from '@/javaApi/order'
import { orderExport } from "../../../../api/order";

const orderModel = new order()
Vue.component('Tooltip', Tooltip)
export default {
  name: 'PromotionOrder',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Detail
  },
  data: function () {
    return {
      platformName: getPlatformName(),
      headImg: getHeadImg(),
      dialog_close: false,
      dialog_intercept: false,
      dialog_urge: false,
      interceptReason: '用户取消',
      activeRow: {},
      columns: [
        // {
        //   title: '影票信息',
        //   key: 'movie_pic',
        //   fixed: 'left',
        //   width: 280,
        //   render: (h, params) => {
        //     let movieName = params.row.movie_name
        //     let movieImage = params.row.movie_pic
        //     let orderTime = params.row.order_create_time
        //     let renderData = []
        //     if(movieImage) {
        //       renderData.push(
        //         h('img',{
        //             attrs:{
        //               src: movieImage, style: 'width: 30%;height: auto;margin:20px;float:left;cursor:pointer;'
        //             },
        //         })
        //       )
        //     }
        //     renderData.push(
        //       h('span', {
        //         attrs: {
        //           style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
        //         }
        //       }, movieName)
        //     ),
        //     renderData.push(
        //       h('span', {
        //         attrs: {
        //           style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
        //         }
        //       }, orderTime)
        //     )
        //     return renderData
        //   }
        // },
        {
          title: '影票信息',
          key: 'movie_name',
          slot: 'movie_name',
          fixed: 'left',
          width: 200,
          // render: (h, params) => {
          //   let movieName = params.row.movie_name
          //   let renderData = []
          //   renderData.push(
          //     h('span', {
          //       attrs: {
          //         style:'display: block;cursor: pointer;float: left;margin-top: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'
          //       }
          //     }, movieName)
          //   )
          //   return renderData
          // }
        },
        {
          title: '订单编号',
          key: 'order_id',
          width: 180,
        },
        {
          title: '第三方单号',
          key: 'third_order_id',
          width: 180,
        },
        {
          title: '第三方平台店铺',
          key: 'storeName',
          slot: 'thirdPartyStore',
          width: 180,
        },
        {
          title: '手机号',
          key: 'reserved_phone',
          width: 140,
        },
        {
          title: '市场价',
          key: 'init_price',
          width: 120,
        },
        {
          title: '数量',
          key: 'order_num',
          width: 80,
        },
        {
          title: '平台折扣价',
          key: 'advice_price',
          slot: 'advice_price',
          width: 140,
        },
        {
          title: '用户支付金额',
          key: 'order_price',
          slot: 'order_priceApi',
          width: 140,
        },
        {
          title: '出票票商',
          key: 'sellerName',
          slot: 'ticketSeller',
          width: 180,
        },
        {
          title: '成本价',
          key: 'order_price',
          slot: 'order_price',
          width: 120,
        },
        {
          title: '成本折扣',
          key: 'deductionRatio',
          slot: 'deductionRatio',
          width: 120,
        },
        {
          title: '开票税额',
          key: 'invoice_tax_amount',
          slot: 'invoice_tax_amount',
          width: 120,
        },
        {
          title: '成本价(含税)',
          key: 'invoice_amount',
          slot: 'invoice_amount',
          width: 120,
        },
        {
          title: '退款金额',
          key: 'refund_amount',
          slot: 'refund_amount',
          width: 120,
        },
        {
          title: '订单总佣金',
          key: 'app_commission',
          slot: 'app_commission',
          width: 120,
        },
        // {
        //   title: '推广佣金',
        //   key: 'app_commission',
        //   width: 120,
        // },
        {
          title: '佣金比例',
          key: 'commissionRate',
          slot: 'commissionRate',
          width: 120,
        },

        {
          title: '订单来源',
          key: 'source_type_str',
          width: 120,
        },
        {
          title: '推广位名称',
          key: 'app_name',
          width: 120,
        },
        // {
        //   title: '市场价',
        //   key: 'init_price',
        //   width: 120,
        // },

        // {
        //   title: '推广位',
        //   key: 'app_key',
        //   width: 120,
        // },
        {
          title: '下单时间',
          key: 'order_create_time',
          width: 180,
        },
        // {
        //   title: '放映时间',
        //   key: 'show_time',
        //   width: 180,
        // },
        {
          title: '结算时间',
          key: 'settle_time',
          renderHeader: (h, params) => {
            return h('Tooltip', {
              props: {
                transfer: true,
                placement: 'bottom-end' //下右
              }
            },
              [
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  '影票放映后7天内结算'
                ),
                h('div', [
                  h('span', {
                    domProps: {
                      innerHTML: '结算时间'
                    }
                  }),
                  h('img', {
                    attrs: {
                      src: questionBtn
                    },
                    style: {
                      width: '30px'
                    }
                  })
                ])
              ]
            )
          },
          width: 180
        },
        {
          title: '退款时间',
          key: 'refund_time',
          slot: 'refund_time',
          width: 180,
        },
        {
          title: '拦截状态',
          key: 'interceptStatusStr',
          width: 120
        },
        {
          title: '订单状态',
          key: 'order_status_str',
          width: 120
        },
        {
          title: '操作',
          key: 'handle',
          slot: 'handle',
          width: 222,
          fixed: 'right',
        }
      ],
      listLoading: false,
      exportLoading: false,
      status_list: [],
      // list: [],
      testlist: [
        {
          handle: 1
        }
      ],
      list: [],
      total: 0,
      appList: [],
      interceptStatus: [
        { label: '全部', value: '' },
        { label: '未拦截', value: '0' },
        { label: '拦截中', value: '3' },
        { label: '拦截成功', value: '1' },
        { label: '拦截失败', value: '2' },
      ],
      searchForm: {
        page: 1,
        pagesize: 10,
        settlementArr: null,
        order_status: '',
        order_id: '',
        start_time_bak: '',
        end_time_bak: '',
        start_time: '',
        end_time: '',
        sort: '-id',
        app_key: '',
        reserved_phone: '',
        third_order_id: '',
        interceptStatus: '',
        orderType: 1
      },
      hintShow: false
    }
  },
  created() {
    this.setTimeBak()
    this.getList(true)
  },
  methods: {
    setTimeBak() {
      // 默认时间选择框下单时间为7天
      this.searchForm.start_time_bak = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000)
      this.searchForm.end_time_bak = new Date()
    },
    urgeBill(row) {
      console.log('row', row)
      this.dialog_urge = true
      this.activeRow = row
    },
    dialog_urgeBtnOk() {
      orderModel
        .urgeBill({
          orderUUID: this.activeRow.orderUUID,
        })
        .then(res => {
          console.log('res', res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_urge = false
            this.getList(true)
          } else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    dialog_interceptBtnOk() {
      orderModel
        .InterceptOrder({
          orderUUID: this.activeRow.orderUUID,
          interceptReason: this.interceptReason,
          // applicantName: this.platformName,
          applicantName: '开放平台',
          applicantUrl: this.headImg
        })
        .then(res => {
          console.log('res', res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_intercept = false
            // this.hintShow = true
          } else {
            this.$Message.warning(res.data.message)
          }
          this.getList(true)
        })
    },
    dialog_closeBtnOk() {
      orderModel
        .cancelOrder({
          orderUUID: this.activeRow.orderUUID
        })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_close = false
            this.getList(true)
          } else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    interceptBtn(row) {
      // this.interceptReason = ''
      console.log('row', row)
      this.dialog_intercept = true
      this.activeRow = row
    },
    cancelOrderBtn(row) {
      console.log('row', row)
      this.dialog_close = true
      this.activeRow = row
    },
    tableHandle_close() {
      this.dialog_close = true
    },
    buildSearchParams() {
      const searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      if (searchForm.settlementArr) {
        searchForm.settle_start_time = getDate(searchForm.settlementArr[0])
        searchForm.settle_end_time = getDate(searchForm.settlementArr[1])
      }
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      delete searchForm.settlementArr
      return searchForm
    },
    formatDisplayValue(value) {
      return value === null || value === undefined || value === '' ? '-' : value
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      const searchForm = this.buildSearchParams()

      getOrderList(searchForm)
        .then(response => {
          this.listLoading = false
          if (response.code != 200) {
            this.$Message.error(response.msg)
            return
          }
          this.list = response.data.list
          console.log('list', this.list)
          this.total = response.data.total
          if (searchForm.page == 1) {
            this.status_list = response.data.status_list
            this.appList = response.data.appList
          }
        })
        .catch(error => {
          this.listLoading = false
          console.log(error)
        })
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      } else {
        return 'bg-white'
      }
    },
    onFormSearch() {
      console.log(this.searchForm)
      this.getList(true)
    },
    // 重置
    onFormReset() {
      this.searchForm.order_status = ''
      this.searchForm.order_id = ''
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.searchForm.app_key = ''
      this.searchForm.interceptStatus = ''
      this.searchForm.start_time_bak = ''
      this.searchForm.end_time_bak = ''
      this.searchForm.settlementArr = null
      this.searchForm.orderType = ''
      this.searchForm.third_order_id = ''
      this.searchForm.reserved_phone = ''
      this.setTimeBak()
      this.getList(true)
    },
    changePage(value) {
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pagesize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList()
      }
    },
    handelDateChange: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.start_time_bak !== '') {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.end_time_bak !== '') {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    onFormExport: async function () {
      if (this.exportLoading) return
      this.exportLoading = true
      try {
        const searchForm = this.buildSearchParams()

        const exportParams = {
          order_status: searchForm.order_status,
          order_id: searchForm.order_id,
          start_time: searchForm.start_time,
          end_time: searchForm.end_time,
          settle_start_time: searchForm.settle_start_time,
          settle_end_time: searchForm.settle_end_time,
          token: getToken()
        }

        const res = await orderExport(exportParams)
        const message = res.message
        const code = res.code
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if (action === 'confirm') {
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
            }
          });
        } else {
          this.$Message.error(message);
        }
      } finally {
        this.exportLoading = false
      }
    },
    getDetail: function (row) {
      this.$refs.Detail.init(true, row)
    },
    handleClose() {
      this.hintShow = false
    },
    selectType(e) {
      this.searchForm.orderType = e
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0;
  padding-bottom: 20px;
}

.flex {
  display: flex;
  align-items: center;
}

.dialog-content {
  min-height: 120px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .box {
    //width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 25px;

    span {
      color: red;
    }

    // margin-top: 30px;
  }

  .hint {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }

  .placeholder {
    margin-top: 10px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.dialogFooter {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;

  div {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .dialogFooter-ok {
    background-color: #ff8622;
    color: #ffffff;
  }
}

.tableHandleStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff9734;

  span {
    cursor: pointer;
  }

  .intercept {
    color: #ff9734;
  }

  .urge {
    color: #3d9efc;
  }

  .close {
    color: #ff4f76;
  }
}

.wrapper {
  width: 100%;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 1.12rem;
}

.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
  display: inline-block;
  padding-right: 7px;
}

.table-wrapper .show-excel:last-child {
  padding-right: 0px;
}

.table-wrapper .status-text-success {
  font-size: 14px;
  color: #3d9efc;
}

.table-wrapper .status-text-reject {
  font-size: 14px;
  color: #ff8622;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: '\F33D';
}

.search-text {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/order/Index.vue